<template>
  <div>
    <div class="jumbotron">
      <div class="mask tra"></div>
      <b-row class="pt-5 text-left text-white" style="margin:auto;">
        <b-col cols="4" md="2" class="text-right">
          <b-img src="/iconss/traduttori.png" class="rounded-pill bg-white text-center p-2"></b-img>
        </b-col>
        <b-col cols="4" class="">
          <h1>Elenco Traduttori</h1>
        </b-col>
      </b-row>
    </div>

    <b-row class="m-2 mx-auto" style="max-width: 1460px">
      <b-col cols="12" class="bg-white text-left my-3">
        <h1>Ricerca traduttori</h1>
        <br />
        <b-col md="12" class="text-left rounded-5 card" :style="myStyle" id="wrapper">
          <b-row class="p-3">
            <b-col md="2" class="text-left float-left d-block">
              <p>Lingua sorgente</p>
            </b-col>
            <b-col md="4" class="text-left float-left d-block">
              <b-form-group class="bg-white">
                <v-select
                  class="rounded-pill"
                  id="input-language"
                  :options="languages"
                  label="description"
                  placeholder="Lingua sorgente..."
                  name="language"
                  required
                  v-validate="'required'"
                  :reduce="(language) => language.id"
                  v-model="src_select"
                ></v-select>
              </b-form-group>
            </b-col>
            <b-col md="2" class="text-left float-left d-block">
              <p>Lingua di destinazione</p>
            </b-col>
            <b-col md="4" class="text-left float-left d-block">
              <b-form-group class="bg-white">
                <v-select
                  id="input-language"
                  :options="languages"
                  label="description"
                  placeholder="Lingua target..."
                  name="language"
                  :reduce="(language) => language.id"
                  required
                  v-validate="'required'"
                  v-model="dest_select"
                ></v-select>
              </b-form-group>
            </b-col>
            <b-col md="2" class="text-left float-left d-block">
              <p>Ricerca libera</p>
            </b-col>
            <b-col md="10" class="text-left float-left d-block">
              <div class="d-flex my-auto">
                <input
                  class="form-control btn-outline-primary rounded-pill"
                  type="text"
                  placeholder="Search"
                  aria-label="Search"
                  v-model="free_text"
                />
                <button class="btn btn-primary butFile pl-4" id="basic-text1" @click="onSearch()">
                  <small><strong>CERCA</strong></small>
                </button>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-col>
      <b-col md="10"> </b-col>
      <b-col md="12" class="bg-white text-left">
        <hr class="btn-outline-info" />
        <b-form-group>
          <div>
            <b-table sort-icon-left striped hover :items="translators" :fields="fields" :busy="isBusy">
              <template v-slot:cell(dest_languages)="data">
                <div class="d-flex bg-white border rounded-pill p-2 m-1" style="max-width: fit-content;">
                  <div v-for="language in data.item.dest_languages" :key="language.id">
                    <p class="mb-0 mt-0 pr-1">{{ language.flag }} {{ language }}</p>
                  </div>
                </div>
              </template>
              <template v-slot:cell(src_languages)="data">
                <div class="d-flex bg-white rounded-pill border p-2 m-1" style="max-width: fit-content">
                  <div v-for="language in data.item.src_languages" :key="language.id">
                    <p class="mb-0 mt-0 pr-1">{{ language.flag }} {{ language }}</p>
                  </div>
                </div> </template
              ><template v-slot:cell(mother_languages)="data">
                <div class="d-flex bg-white rounded-pill border p-2 m-1" style="max-width: fit-content">
                  <div v-for="language in data.item.mother_languages" :key="language.id">
                    <p class="mb-0 mt-0 pr-1">{{ language.flag }} {{ language }}</p>
                  </div>
                </div>
              </template>

              <template v-slot:cell(last_name)="data">
                <!-- <div class="d-flex p-2 m-1">
                  <p class="font-weight-bold">{{ data.item.last_name }} {{ data.item.first_name }}</p>
                </div> -->
                <div class="d-flex p-2 m-1" style="max-width: fit-content">
                  <p class="font-weight-bold mb-0 mt-1 pr-1">{{ data.item.last_name }} {{ data.item.first_name }}</p>
                </div>
              </template>

              <template v-slot:cell(icon)="data">
                <router-link class="spacing d-flex p-2 m-1" :to="`/translators/view/${data.item.id}`">
                  <b-icon-arrow-right-circle-fill variant="info" font-scale="2"></b-icon-arrow-right-circle-fill>
                </router-link>
              </template>
            </b-table>
          </div>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import util from "@/mixing/util";
import UserService from "@/services/user.service";
export default {
  mixins: [util],
  data() {
    return {
      // Note 'isActive' is left out and will not appear in the rendered table
      fields: [
        {
          key: "last_name",
          label: "Nome",
          //sortable: true
        },
        {
          key: "mother_languages",
          label: "Lingua Madre",
        },
        {
          key: "src_languages",
          label: "Lingue Sorgenti",
        },
        {
          key: "dest_languages",
          label: "Lingue di destinazione",
        },
        {
          key: "icon",
          label: "",
        },
      ],
      translators: [],
      isBusy: false,
      languages: [],
      myStyle: {
        backgroundColor: "#f3f3f3",
        height: "auto",
      },
      src_select: null,
      dest_select: null,
      free_text: "",
    };
  },
  created(){
    if(localStorage.dest_lang)
      localStorage.removeItem('dest_lang');
  },
  async mounted() {
    this.isBusy = true;

    UserService.getLanguages().then((response) => (this.languages = response.data));
    await this.getTranslators();
    this.isBusy = false;
  },
  methods: {
    getLanguageDescription(languageCode) {
      let l = this.languages.find((x) => x.id == languageCode);
      if (l !== undefined) {
        return l.description;
      }
      return "";
    },
    onSearch() {
      this.$router.push({
        query: {
          src: this.src_select,
          dest: this.dest_select,
          q: this.free_text,
        },
      });
      this.getTranslators();
    },

    async getTranslators() {
      UserService.getTranslators(window.location.search).then((response) => {
        this.translators = response.data;
      });
    },
  },
  computed: {},
};
</script>

<style scoped>
.jumbotron {
  background-image: url("/img/bg-tra.png");
}
.mask.tra {
  background-color: #0e82ae;
}
.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(14, 130, 174, 0.05);
}
</style>
